import React from 'react'
import { FaArrowRight } from "react-icons/fa";
function AboutNew() {
  return (
      <div className="container-fluid" style={{ marginTop: "30px", marginBottom: "30px" }}>
       
      <div className="row align-items-center mb-4  ">
        {/* Left Side Image with 18+ Years Box */}
      
        <div className="col-md-6 position-relative">
          <img
             src="/img/Chitracrop.png"
                    alt="image"
            className="shadow w-100 product-img-out"
          />
          {/* <div className="years-box position-absolute top-50 start-0 translate-middle-y text-white text-center fw-bold">
            <span className="d-block fs-3">18+</span>
            <small className="text-uppercase">Years Of</small>
            <br />
            <small className="text-uppercase">Experiences</small>
          </div> */}
        </div>

        {/* Right Side Content */}
        <div className="col-md-6 mt-4 mt-md-0">
          <h3 className="text-danger fw-bold">About us</h3>
          <h2 className="fw-bold text-danger">CHITRACROP SCIENCE</h2>
          <p className="text-dark fw-bold">
      Chitracrop Science is a forward-thinking agri-science company committed to revolutionizing modern farming through innovation, research, and sustainability. We specialize in developing advanced solutions for crop protection, plant nutrition, and soil health management that help farmers achieve higher productivity and profitability. With a strong focus on quality, technology, and eco-friendly practices, Chitracrop Science works to bridge the gap between scientific innovation and practical farming needs. Our mission is to empower farmers with smart, sustainable, and result-oriented agri-products that ensure healthy crops, improved yields, and a greener, more prosperous future for agriculture.
          </p>

         

          <button className="btn btn-danger mt-3">
       <a href="/blogs-news" style={{ color: "white", textDecoration: "none" }}>
            MORE <FaArrowRight className="ms-2" />
         </a>
          </button>
        </div>
      </div>
     
    </div>

  )
}

export default AboutNew